import React from 'react';
import PropTypes from 'prop-types';
import { favoriteItemUpload } from '@bd/bdcore-data/build/Favorites/actions';
import withData from '@bd/bdcore-data';

class FavoriteUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      notes: '',
    };
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.files ? event.target.files[0] : event.target.value;

    this.setState({
      [key]: value,
    });
  }

  upload = () => {
    const { file, title, notes } = this.state;
    const { dispatch } = this.props;

    const item = {
      favoriteId: Date.now(),
      title,
      notes,
      type: 'upload',
      favoritedAt: Date.now(),
    };

    dispatch(favoriteItemUpload(item, file));

    this.setState({
      file: null,
      title: null,
      notes: null,
    });
  }

  render() {
    const { className } = this.props;
    const { file } = this.state;

    return (
      <div className={`${className || ''} FavoriteUpload`}>
        <div className="FavoriteUpload_formSection container">
          <div className="form-group">
            <label htmlFor="title">Title</label>
            <input className="form-control" type="text" name="title" id="title" onChange={this.handleInput} required />
          </div>
          <div className="form-group">
            <label htmlFor="notes">Notes</label>
            <textarea className="form-control" name="notes" id="notes" onChange={this.handleInput} required />
          </div>
          <div className="form-group">
            <label htmlFor="file">File</label>
            <input className="form-control no-border" type="file" name="file" id="file" onChange={this.handleInput} required accept="image/*" />
          </div>
          <button type="button" className="btn" onClick={this.upload} disabled={!file}>Upload</button>
        </div>
      </div>
    );
  }
}

FavoriteUpload.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

FavoriteUpload.defaultProps = {
  className: undefined,
};

export default withData({})(FavoriteUpload);



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/Favorites/FavoriteUpload.js